<template>
	<div class="missing-logs">
		<el-row v-loading="isLoading" :gutter="20">
			<el-col :span="24" style="padding: 1rem; background: #ffffff">
				<h4 class="text-center missing-log-title">
					Missing Logs
					<span
						>({{ fromDate | formatDateValue }} to
						{{ toDate | formatDateValue }})</span
					>
				</h4>
				<div style="width: 100%">
					<Bar
						:chart-options="options"
						:chart-data="dataSets"
						:height="300"
						:plugins="plugins"
					/>
				</div>
			</el-col>
		</el-row>
		<el-row v-loading="isLoading" :gutter="20" class="mt-6">
			<el-col :span="24" style="padding: 1rem; background: #ffffff">
				<div
					class="mb-2"
					style="
						display: flex;
						justify-content: space-between;
						position: relative;
					"
				>
					<h4 class="text-center missing-log-title my-4">
						Missing Logs
						<span
							>({{ fromDate | formatDateValue }} to
							{{ toDate | formatDateValue }})</span
						>
					</h4>
					<!-- <el-input v-model="searchText" placeholder="Search" suffix-icon="el-icon-search" style="width: 200px; right: 80px" size="mini" /> -->
					<el-button
						v-if="dashboardTab == 'other' && currentStep == 'task'"
						class="btn submit-btn"
						size="mini"
						icon="el-icon-download"
						style="margin-left: 10px; position: absolute; bottom: 0; right: 0"
						@click="downloadCategoryPerformanceDetails()"
						>Download Reports</el-button
					>
					<el-button
						v-else-if="dashboardTab == 'other' && currentStep == 'subtask'"
						class="btn submit-btn"
						size="mini"
						icon="el-icon-back"
						style="margin-left: 10px; position: absolute; bottom: 0; right: 0"
						@click="resetData()"
						>Back</el-button
					>
					<el-button
						v-else-if="dashboardTab == 'audit' && currentAuditMissingLogStep == 'category'"
						class="btn submit-btn"
						size="mini"
						icon="el-icon-download"
						style="margin-left: 10px; position: absolute; bottom: 0; right: 0"
						@click="exportAuditMissingLogByCategoryCSV"
						>Download Reports</el-button
					>
					<template v-else-if="dashboardTab == 'audit' && currentAuditMissingLogStep == 'task'">
						<el-button
							class="btn submit-btn"
							size="mini"
							icon="el-icon-download"
							style="margin-left: 10px; position: absolute; bottom: 0; right: 80px"
							@click="exportAuditMissingLogByTaskCSV"
							>Download Reports</el-button
						>
						<el-button
							class="btn submit-btn"
							size="mini"
							icon="el-icon-back"
							style="margin-left: 10px; position: absolute; bottom: 0; right: 0"
							@click="currentAuditMissingLogStep = 'category'"
							>Back</el-button
						>
					</template>
					<template v-else-if="dashboardTab == 'audit' && currentAuditMissingLogStep == 'subtask'">
						<el-button
							class="btn submit-btn"
							size="mini"
							icon="el-icon-download"
							style="margin-left: 10px; position: absolute; bottom: 0; right: 80px"
							@click="exportAuditMissingLogBySubTaskCSV"
							>Download Reports</el-button
						>
						<el-button
							class="btn submit-btn"
							size="mini"
							icon="el-icon-back"
							style="margin-left: 10px; position: absolute; bottom: 0; right: 0"
							@click="currentAuditMissingLogStep = 'task'"
							>Back</el-button
						>
					</template>
					
				</div>
				<!-- <h2 class="text-center missing-log-title my-4">Missing Logs - {{ fromDate }} to {{ toDate }}</h2> -->
				<template v-if="dashboardTab == 'other'">
					<div v-if="!isLoading && currentStep == 'task'" class="task-missing-log-container" style="width: 100%">
						<el-table
							:data="filteredMissingLogs"
							style="width: 100%"
							max-height="400"
							class="custom-category__details-table"
						>
							<el-table-column
								fixed
								prop="Task"
								label="Task"
								align="center"
								min-width="150"
							>
								<template slot="header" slot-scope="scope">
									Task
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="search"
											size="mini"
											placeholder="Search Task"
										></el-input>
										<div
											style="max-height: 250px; overflow: auto; margin-top: 10px"
										>
											<el-checkbox-group v-model="selectedTask">
												<template
													v-if="missingLogsTasks
													&&
													missingLogsTasks.length"
												>
													<!-- <el-checkbox
													v-for="(task, index) in taskItems.filter(
														(data) =>
															!search ||
															data.value
																.toLowerCase()
																.includes(search.toLowerCase())
													)"
													:key="index"
													class="mb-2 checkbox-lable"
													:label="task.value"
													style="display: block"
												></el-checkbox> -->
													<el-checkbox
														v-for="(task, index) in missingLogsTasks.filter(
															(el) =>
																!search ||
																el.toLowerCase().includes(search.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="task"
														style="display: block"
													></el-checkbox>
												</template>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selectAll('task')"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="resetSelection('task')"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selectedTask.length"
												src="../../../../../../src/assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../../../src/assets/images/filter-icon.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<span
										class="scoped_task"
										@click="getSubTask(scope.row.task_id)"
										v-html="scope.row.Task"
									></span>
								</template>
							</el-table-column>
							<el-table-column
								fixed
								prop="Category"
								label="Category"
								align="center"
								min-width="150"
							>
								<template slot="header" slot-scope="scope">
									Category
									<el-popover placement="right" trigger="click">
										<el-input
											v-model="searchCat"
											size="mini"
											placeholder="Search Category"
										></el-input>
										<div
											style="max-height: 250px; overflow: auto; margin-top: 10px"
										>
											<el-checkbox-group v-model="selectedCategory">
												<template
													v-if="missingLogsCategories
													&&
													missingLogsCategories.length"
												>
													<el-checkbox
														v-for="(
															category, index
														) in missingLogsCategories.filter(
															(el) =>
																!searchCat ||
																el.toLowerCase().includes(searchCat.toLowerCase())
														)"
														:key="index"
														class="mb-2 checkbox-lable"
														:label="category"
														style="display: block"
													></el-checkbox>
												</template>
											</el-checkbox-group>
										</div>
										<div class="flex justify-between mt-4">
											<span
												class="text-xs cursor-pointer primary-theme-color"
												@click="selectAll('cat')"
												>Select all</span
											>
											<span
												class="text-xs cursor-pointer"
												@click="resetSelection('cat')"
												>Reset</span
											>
										</div>
										<span slot="reference">
											<img
												v-if="selectedCategory.length"
												src="../../../../../../src/assets/images/filter.png"
												width="9"
												class="cursor-pointer"
											/>
											<img
												v-else
												src="../../../../../../src/assets/images/filter-icon.png"
												width="9"
												class="cursor-pointer"
											/>
										</span>
									</el-popover>
								</template>
								<template slot-scope="scope">
									<span v-html="scope.row.Category"></span>
								</template>
							</el-table-column>
							<template v-for="(item, index) in labels">
								<el-table-column
									:key="'table-item-' + index"
									v-if="item != 'Task'"
									sortable
									:prop="item"
									:label="item"
									min-width="150"
									align="center"
								>
									<template slot-scope="scope">
										<span v-html="scope.row[item]"></span>
									</template>
								</el-table-column>
							</template>
						</el-table>
	
						<div
							v-if="currentStep == 'subtask'"
							class="table-outer task-table-outer event-table task-query"
						>
							<table class="task-table report-tbl-inner mt-2">
								<thead>
									<tr>
										<!-- <th class="task-fix-div fix-div" style="width: 200px"> -->
										<th class="task-fix-div fix-div" style="width: 161px">
											TASK
										</th>
	
										<th
											v-for="(i, index) in subtasks_reports_dates"
											:key="index + new Date().getTime() * 10"
											:style="[
												subtasks_reports_dates.length > 10
													? { width: '110px' }
													: { width: 100 / subtasks_reports_dates.length + '%' },
											]"
										>
											{{ i | formatReportDate }}
										</th>
									</tr>
								</thead>
	
								<tbody>
									<template v-if="task_reports_subtasks.length > 0">
										<tr
											v-for="(item, index) in task_reports_subtasks"
											:key="'task-report-emp-' + index"
										>
											<td class="task-fix-div fix-div" style="width: 200px">
												<div
													style="text-transform: capitalize"
													v-html="item.name"
												></div>
												<div
													v-if="
														(item.num_value_min != 0 ||
															item.num_value_max != 0) &&
														item.num_value_min != '' &&
														item.num_value_max != '' &&
														item.num_value_min != null &&
														item.num_value_max != null
													"
												>
													({{ item.num_value_min }}&deg; C to
													{{ item.num_value_max }}&deg; C)
												</div>
											</td>
	
											<td
												v-for="(i, subtasks_reports_dates_index) in subtasks_reports_dates"
												:key="'task-report-date-column-' + subtasks_reports_dates_index"
												:style="[
													subtasks_reports_dates.length > 10
														? { width: '110px' }
														: {
																width: 100 / subtasks_reports_dates.length + '%',
															},
												]"
											>
												<template v-if="item.records[0].subtask_type == 'image'">
													<template
														v-if="checkIfTaskIsCompleted(item.records, i)"
													>
														<div class="mt-2">
															<i
																style="color: #67c23a"
																class="text-base el-icon-success"
															></i>
														</div>
													</template>
													<template v-else>
														<div class="mt-2">
															<i
																style="color: #f56c6c"
																class="text-base el-icon-error"
															></i>
														</div>
													</template>
												</template>
												<template v-if="checkIfTaskIsCompleted(item.records, i)">
													<div v-html="getTaskValue(item.records, i)"></div>
												</template>
												<template v-else>
													<div class="mt-2">-</div>
												</template>
												<template v-if="checkIfDateHasImage(item.records, i)">
													<div class="mt-2">
														<span
															style="cursor: pointer; text-decoration: underline"
															@click="openAttachmentsModal(item.records, i)"
															>View Image</span
														>
													</div>
												</template>
												<template v-if="checkIfDateHasComment(item.records, i)">
													<div class="mt-2">
														<span
															style="cursor: pointer; text-decoration: underline"
															@click="openCommentModal(item.records, i)"
															>View Comment</span
														>
													</div>
												</template>
											</td>
										</tr>
									</template>
	
									<tr v-else>
										<td colspan="7">NO DATA AVAILABLE</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div
						v-if="currentStep == 'subtask'"
						class="table-outer task-table-outer event-table task-query"
					>
						<table class="task-table report-tbl-inner mt-2">
							<thead>
								<tr>
									<th class="task-fix-div fix-div" style="width: 161px">TASK</th>

									<th
										v-for="(i, index) in subtasks_reports_dates"
										:key="index + new Date().getTime() * 10"
										:style="[
											subtasks_reports_dates.length > 10
												? { width: '110px' }
												: { width: 100 / subtasks_reports_dates.length + '%' },
										]"
									>
										{{ i | formatReportDate }}
									</th>
								</tr>
							</thead>

							<tbody>
								<template v-if="task_reports_subtasks.length > 0">
									<tr
										v-for="(item, index) in task_reports_subtasks"
										:key="'task-report-emp-' + index"
									>
										<td class="task-fix-div fix-div" style="width: 161px">
											<div
												style="text-transform: capitalize"
												v-html="item.name"
											></div>
											<div
												v-if="
													(item.num_value_min != 0 || item.num_value_max != 0) &&
													item.num_value_min != '' &&
													item.num_value_max != '' &&
													item.num_value_min != null &&
													item.num_value_max != null
												"
											>
												({{ item.num_value_min }}&deg; C to
												{{ item.num_value_max }}&deg; C)
											</div>
										</td>

										<td
											v-for="(i, subtasks_reports_dates_index) in subtasks_reports_dates"
											:key="'task-report-date-column-' + subtasks_reports_dates_index"
											:style="[
												subtasks_reports_dates.length > 10
													? { width: '110px' }
													: { width: 100 / subtasks_reports_dates.length + '%' },
											]"
										>
											<template v-if="item.records[0].subtask_type == 'image'">
												<template v-if="checkIfTaskIsCompleted(item.records, i)">
													<div class="mt-2">
														<i
															style="color: #67c23a"
															class="text-base el-icon-success"
														></i>
													</div>
												</template>
												<template v-else>
													<div class="mt-2">
														<i
															style="color: #f56c6c"
															class="text-base el-icon-error"
														></i>
													</div>
												</template>
											</template>
											<template v-if="checkIfTaskIsCompleted(item.records, i)">
												<!-- <div v-html="getTaskValue(item.records, i)"></div> -->
												<div></div>
											</template>
											<template v-else>
												<div class="mt-2">
													<i
														class="el-icon-error text-danger text-lg"
														style="color: #f56c6c !important"
													></i>
												</div>
											</template>
											<template v-if="checkIfDateHasImage(item.records, i)">
												<div class="mt-2">
													<!-- <span
														style="cursor: pointer; text-decoration: underline"
														@click="openAttachmentsModal(item.records, i)"
														>View Image</span
													> -->
												</div>
											</template>
											<template v-if="checkIfDateHasComment(item.records, i)">
												<!-- <div class="mt-2">
													<span
														style="cursor: pointer; text-decoration: underline"
														@click="openCommentModal(item.records, i)"
														>View Comment</span
													>
												</div> -->
											</template>
										</td>
									</tr>
								</template>

								<tr v-else>
									<td colspan="7">NO DATA AVAILABLE</td>
								</tr>
							</tbody>
						</table>
					</div>
				</template>
				<template v-else-if="dashboardTab == 'audit'">
					<div v-if="!isLoading" style="width: 100%">
						<div v-if="currentAuditMissingLogStep == 'category'" style="width: 100%">
							<el-table
								:data="filteredAuditMissingLogsCategoryList"
								style="width: 100%"
								max-height="400"
								class="custom-category__details-table"
							>
								<el-table-column
									fixed
									label="Category"
									align="center"
									min-width="150"
								>
									<template slot="header" slot-scope="scope">
										Category
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searchedAuditCategory"
												size="mini"
												placeholder="Search Category"
											></el-input>
											<div
												style="max-height: 250px; overflow: auto; margin-top: 10px"
											>
												<el-checkbox-group v-model="selectedAuditCategories">
													<template v-if="auditMissingLogsCategories && auditMissingLogsCategories.length">
														<el-checkbox
															v-for="(task, index) in auditMissingLogsCategories.filter(
																(el) =>
																	!searchedAuditCategory ||
																	el.toLowerCase().includes(searchedAuditCategory.toLowerCase())
															)"
															:key="index"
															class="mb-2 checkbox-lable"
															:label="task"
															style="display: block"
														></el-checkbox>
													</template>
												</el-checkbox-group>
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selectedAuditCategories = [...auditMissingLogsCategories]"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selectedAuditCategories = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selectedAuditCategories.length"
													src="../../../../../../src/assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../../../../src/assets/images/filter-icon.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</template>
									<template slot-scope="scope">
										<div class="scoped_task" @click="selectAuditMissingLogByCategory(scope.row.category_id, scope.row.intermediate_category_name)" v-html="scope.row.category_name"></div>
									</template> 
								</el-table-column>
								<el-table-column
									fixed
									prop="intermediate_category_name"
									label="Intermediate Category"
									align="center"
									min-width="200"
								>
									<template slot="header" slot-scope="scope">
										Intermediate Category
										<el-popover placement="right" trigger="click">
											<el-input
												v-model="searchedAuditIntermediateCategory"
												size="mini"
												placeholder="Search Intermediate Category"
											></el-input>
											<div
												style="max-height: 250px; overflow: auto; margin-top: 10px"
											>
												<el-checkbox-group v-model="selectedAuditIntermediateCategories">
													<template
														v-if="auditMissingLogsIntermediateCategories
														&&
														auditMissingLogsIntermediateCategories.length"
													>
														<el-checkbox
															v-for="(task, index) in auditMissingLogsIntermediateCategories.filter(
																(el) =>
																	!searchedAuditIntermediateCategory ||
																	el.toLowerCase().includes(searchedAuditIntermediateCategory.toLowerCase())
															)"
															:key="index"
															class="mb-2 checkbox-lable"
															:label="task"
															style="display: block"
														></el-checkbox>
													</template>
												</el-checkbox-group>
											</div>
											<div class="flex justify-between mt-4">
												<span
													class="text-xs cursor-pointer primary-theme-color"
													@click="selectedAuditIntermediateCategories = [...auditMissingLogsIntermediateCategories]"
													>Select all</span
												>
												<span
													class="text-xs cursor-pointer"
													@click="selectedAuditIntermediateCategories = []"
													>Reset</span
												>
											</div>
											<span slot="reference">
												<img
													v-if="selectedAuditIntermediateCategories.length"
													src="../../../../../../src/assets/images/filter.png"
													width="9"
													class="cursor-pointer"
												/>
												<img
													v-else
													src="../../../../../../src/assets/images/filter-icon.png"
													width="9"
													class="cursor-pointer"
												/>
											</span>
										</el-popover>
									</template>
								</el-table-column>
								<el-table-column
									v-for="(dateItem, dateIndex) in dateLabels"
									:key="'date-'+dateIndex"
									:label="dateItem"
									align="center"
									min-width="150"
								>
									<template slot-scope="scope">
										<div v-html="scope.row[dateItem]"></div>
									</template> 
								</el-table-column>
							</el-table>
						</div>
						<div v-else-if="currentAuditMissingLogStep == 'task'" style="width: 100%">
							<el-table
								:data="auditMissingLogsTaskList"
								style="width: 100%"
								max-height="400"
								class="custom-category__details-table"
							>
								<el-table-column
									label="Task"
									align="center"
									min-width="220"
									fixed
								>
									<template slot-scope="scope">
										<div class="missing-log-link-text">
											<div @click="selectAuditMissingLogByTask(scope.row.task_id, scope.row.intermediate_category)">{{ scope.row.task }}</div>
										</div>
									</template>
								</el-table-column>
								<el-table-column
									prop="category"
									label="Category"
									align="center"
									min-width="150"
									fixed
								></el-table-column>
								<el-table-column
									prop="intermediate_category"
									label="Intermediate Category"
									align="center"
									min-width="180"
									fixed
								></el-table-column>
								<el-table-column
									v-for="(item, index) in dateLabels"
									:key="'date-label-audit-task-'+index"
									:label="item"
								>
									<template slot-scope="scope">
										<div v-html="scope.row[item]"></div>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<div v-else-if="currentAuditMissingLogStep == 'subtask'" style="width: 100%">
							<el-table
								:data="auditMissingLogsSubTaskList"
								style="width: 100%"
								max-height="400"
								class="custom-category__details-table"
							>
								<el-table-column
									label="Sub Task"
									align="center"
									min-width="150"
									fixed
								>
									<template slot-scope="scope">
										<div class="missing-log-title-text">{{ scope.row.subtask }}</div>
									</template>
								</el-table-column>
								<el-table-column
									v-for="(item, index) in dateLabels"
									:key="'date-label-audit-task-'+index"
									:label="item"
								>
									<template slot-scope="scope">
										<div v-html="scope.row[item]"></div>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</div>
				</template>
			</el-col>
		</el-row>

		<!-- Task Report Image Modal -->
		<el-dialog
			:visible.sync="showTaskReportsImageModal"
			:close-on-click-modal="true"
			width="90%"
			top="0"
			custom-class="customClass image_modal_task_reports"
			:lock-scroll="true"
			:show-close="true"
			:fullscreen="true"
		>
			<span slot="title"></span>
			<div style="padding: 0 20px 0 20px" class="text-left">
				<el-button
					icon="el-icon-back"
					class="submit-btn"
					size="mini"
					@click="showTaskReportsImageModal = false"
				>
					Back
				</el-button>
			</div>

			<div style="padding: 30px 20px">
				<div v-if="taskReportsImgArr.length == 0" style="text-align: center">
					<p>No image available</p>
				</div>
				<div v-else>
					<el-row :gutter="20">
						<el-col
							v-for="(item, index) in taskReportsImgArr"
							:key="'task-item-image-' + index"
							:xs="8"
							:sm="8"
							:md="8"
							:lg="8"
							:xl="8"
						>
							<img :src="item" style="width: 100%" />
						</el-col>
					</el-row>
				</div>
			</div>
		</el-dialog>
		<!-- ./Task Report Image Modal -->

		<!-- Task Report Comment Modal -->
		<el-dialog
			:visible.sync="showTaskReportsCommentModal"
			:close-on-click-modal="true"
			width="90%"
			top="0"
			custom-class="customClass comment_modal_task_reports"
			:lock-scroll="true"
			:show-close="true"
			:fullscreen="true"
		>
			<span slot="title"></span>
			<div style="padding: 0 20px 0 20px" class="text-left">
				<el-button
					icon="el-icon-back"
					class="submit-btn"
					size="mini"
					@click="showTaskReportsCommentModal = false"
				>
					Back
				</el-button>
			</div>
			<div style="padding: 30px 20px">
				<el-row :gutter="20">
					<el-col
						v-if="taskReportsImageComment"
						:xs="24"
						:sm="24"
						:md="24"
						:lg="24"
						:xl="24"
					>
						<p class="mt-4">{{ taskReportsImageComment }}</p>
					</el-col>
				</el-row>
			</div>
		</el-dialog>
		<!-- ./Task Report Comment Modal -->
	</div>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import {
	Chart as ChartJS,
	Title,
	Tooltip,
	Legend,
	BarElement,
	CategoryScale,
	LinearScale,
} from "chart.js";
// import ChartDatalabels from "chartjs-plugin-datalabels";
import moment from "moment";
import exportFromJSON from "export-from-json";
import LabourPalnningService from "../../../../../services/labourPalnningService";
export default {
	name: "MissingLog",
	components: {
		Bar,
	},
	filters: {
		formatDateValue(value) {
			return moment(value).format("Do MMM YY");
		},
		formatReportDate(date) {
			if (date) {
				let d = new Date(date);
				return moment(d).format("Do MMM YYYY");
			}
		},
	},
	props: {
		missingLogType: {
			type: String,
			default: "overall_missing_logs",
		},
		fromDate: {
			type: String,
			default: null,
		},
		toDate: {
			type: String,
			default: null,
		},
		logReports: {
			type: Array,
			default: () => [],
		},
		isLoading: {
			type: Boolean,
			default: false,
		},
		storeList: {
			type: Array,
			default: () => [],
		},
		selectedOutlet: {
			type: String,
			default: null,
		},
		dashboardTab: {
			type: String,
			default: null,
		},
		auditIntermediateCategories: {
			type: Array,
			default: () => []
		},
		taskIntermediateCategories: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			newValue: [],
			arr: [],
			searchCat: "",
			selectedTask: [],
			selectedCategory: [],
			search: "",
			visible: false,
			search_location_for_task: "",
			selected_location_filter_for_task: [],
			location_for_task_reports: [],
			dataSets: {
				labels: [],
				datasets: [
					{
						label: "Y",
						backgroundColor: [],
						data: [],
						borderWidth: 2,
						datalabels: {
							color: "#fff",
							backgroundColor: "#d26300",
						},
					},
					{
						label: "N",
						backgroundColor: [],
						data: [],
						borderWidth: 2,
						datalabels: {
							color: "#fff",
							backgroundColor: "#d60918",
							anchor: "center",
							align: "top",
						},
					},
				],
				plugins: [ChartDatalabels],
			},
			plugins: {
				datalabels: {
					display: true,
					anchor: "end",
					align: "top",
					clamp: true,
					fontColor: "#fff",
				},
			},
			options: {
				responsive: true,
				legend: {
					display: false,
				},
				maintainAspectRatio: false,
				categoryPercentage: 2,
				layout: {
					padding: {
						left: 0,
						right: 0,
						top: 15,
						bottom: 0,
					},
				},
				scales: {
					xAxes: [
						{
							stacked: true, // this should be set to make the bars stacked
						},
					],
					yAxes: [
						{
							stacked: true, // this also..
						},
					],
				},
			},
			labels: [],
			missingLogData: [],
			currentStep: "task",
			task_reports_subtasks: [],
			subtasks_reports_dates: [],
			taskReportsImgArr: [],
			showTaskReportsImageModal: false,
			taskReportsImageComment: "",
			showTaskReportsCommentModal: false,
			searchText: "",
			allData: [],
			taskItems: [],
			categoryItems: [],
			missingLogData1: [],
			currentAuditMissingLogStep: "category",
			selectedAuditMissingLogCategoryId: "",
			selectedAuditMissingLogTaskId: "",
			auditMissingLogsCategoryList: [],
			auditMissingLogsTaskList: [],
			auditMissingLogsSubTaskList: [],
			selectedAuditMissingLogIntermediateCategory: null,
			searchedAuditCategory: '',
			selectedAuditCategories: [],
			searchedAuditIntermediateCategory: '',
			selectedAuditIntermediateCategories: [],
			is_loading: false,
		};
	},
	computed: {
		store_name() {
			let store_list = [...this.storeList];
			let store_name = "";
			const toTitleCase = (str) => {
				return str.replace(/\w\S*/g, function (txt) {
					return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
				});
			};
			if (this.selectedOutlet) {
				let storeData = store_list.find((el) => el.id == this.selectedOutlet);
				if (storeData !== undefined) {
					store_name = toTitleCase(storeData.name);
				}
			}
			return store_name;
		},
		filteredMissingLogs() {
			let result = [...this.missingLogData1];
			if (this.selectedTask && this.selectedTask.length) {
				result = result.filter((el) =>
					this.selectedTask.includes(
						el["Task"].replace("<div>", "").replace("</div>", "").trim()
					)
				);
			}
			if (this.selectedCategory && this.selectedCategory.length) {
				result = result.filter((el) =>
					this.selectedCategory.includes(el["Category"])
				);
			}
			if (this.missingLogType == "equipments_and_products_missing_logs") {
				result = result.filter((el) => {
					if (
						el.Category == "PM Checklist" ||
						el.Category == "AM Checklist" ||
						el.Category == "Broiler Checklist" ||
						el.Category == "Dessert Checklist"
					) {
						return el.Category;
					}
				});
			}
			return result;
		},
		missingLogsTasks() {
			return [
				...new Set(
					this.missingLogData1.map((el) =>
						el.Task.replace("<div>", "").replace("</div>", "").trim()
					)
				),
			];
		},
		missingLogsCategories() {
			if (this.missingLogType == "equipments_and_products_missing_logs") {
				let arr = [
					...new Set(
						this.missingLogData1.map((el) => {
							if (
								el.Category == "PM Checklist" ||
								el.Category == "AM Checklist" ||
								el.Category == "Broiler Checklist" ||
								el.Category == "Dessert Checklist"
							) {
								return el.Category;
							}
						})
					),
				];
				arr = arr.filter((el) => {
					if (el != undefined) {
						return el;
					}
				});
				return arr;
			} else {
				return [...new Set(this.missingLogData1.map((el) => el.Category))];
			}
		},
		dateLabels() {
			let startDate = this.fromDate;
			let endDate = this.toDate;
			let result = this.getDateRange(startDate, endDate);
			return result;
		},
		auditMissingLogsCategories() {
			let data = [...this.auditMissingLogsCategoryList];
			let result = [... new Set(data.filter(el => el.category_name).map(el => el.category_name.replace('<div>', '').replace('</div>', '')))];
			return result;
		},
		auditMissingLogsIntermediateCategories() {
			let data = [...this.auditMissingLogsCategoryList];
			let result = [... new Set(data.filter(el => el.intermediate_category_name).map(el => el.intermediate_category_name))];
			return result;
		},
		filteredAuditMissingLogsCategoryList() {
			let result = [...this.auditMissingLogsCategoryList];
			if(this.selectedAuditCategories && this.selectedAuditCategories.length) {
				result = result.filter(el => this.selectedAuditCategories.includes(`${el.category_name.replace('<div>', '').replace('</div>', '')}`));
			}
			if(this.selectedAuditIntermediateCategories && this.selectedAuditIntermediateCategories.length) {
				result = result.filter(el => this.selectedAuditIntermediateCategories.includes(el.intermediate_category_name));
			}
			return result;
		},
	},
	watch: {
		logReports(newValue, oldValue) {
			let tempArr = [...JSON.parse(JSON.stringify(newValue))];
			if (this.dashboardTab == 'other' && this.missingLogType == "equipments_and_products_missing_logs") {
				tempArr = [
					...tempArr.filter((el) => el.category_name != "Food safety Top 12"),
				];
			}
			if(this.dashboardTab == 'other') {
				this.formatData(tempArr);
			} else {
				this.formatAuditMissingLogs(tempArr);
			}
		},
		selectedCategory(val) {
			console.log(val, "vl");
		},
	},
	mounted() {
		ChartJS.register(
			Title,
			Tooltip,
			Legend,
			BarElement,
			CategoryScale,
			LinearScale,
			ChartDatalabels
		);
	},
	methods: {
		get_unique_values(list) {
			let jsonObject = list.map(JSON.stringify);
			let uniqueSet = new Set(jsonObject);
			let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
			return uniqueArray;
		},
		filterLog(arr) {
			console.log(arr, "arr");
		},
		updateListCategory(val) {
			let arr = [];
			[...this.missingLogData1].filter((item) => {
				val.map((task) => {
					if (item.Category.includes(task)) arr.push(item);
				});
			});
			this.missingLogData = arr;
		},
		updateList(val) {
			let arr = [];
			[...this.missingLogData1].filter((item) => {
				val.map((task) => {
					if (item.Task.includes(task)) arr.push(item);
				});
			});
			this.missingLogData = arr;
		},
		selectAll(type) {
			switch (type) {
				case "task":
					this.selectedTask = [];
					this.selectedTask = this.taskItems.map((el) => el.value);
					this.missingLogData = this.missingLogData1;
					break;
				case "cat":
					this.selectedCategory = [];
					this.selectedCategory = this.categoryItems.map((el) => el.value);
					this.missingLogData = this.missingLogData1;
					break;
				default:
					break;
			}
		},
		resetSelection(type) {
			switch (type) {
				case "task":
					this.selectedTask = [];
					setTimeout(() => {
						this.missingLogData = this.missingLogData1;
					}, 50);
					break;
				case "cat":
					this.selectedCategory = [];
					setTimeout(() => {
						this.missingLogData = this.missingLogData1;
					}, 50);
					break;
				default:
					break;
			}
		},
		removeDuplicates(arr, key, type) {
			if (type == "task") {
				this.taskItems = [
					...new Map(arr.map((item) => [item[key], item])).values(),
				];
			}
			if (type == "category") {
				this.categoryItems = [
					...new Map(arr.map((item) => [item[key], item])).values(),
				];
				if (this.missingLogType == "equipments_and_products_missing_logs") {
					this.categoryItems = [...this.categoryItems].filter((item) => {
						if (
							item.value == "PM Checklist" ||
							item.value == "AM Checklist" ||
							item.value == "Broiler Checklist" ||
							item.value == "Dessert Checklist"
						) {
							return item;
						}
					});
				} else {
					this.categoryItems = [
						...new Map(arr.map((item) => [item[key], item])).values(),
					];
				}
			}
		},
		getDateRange(startDate, stopDate) {
			let dateArray = [];
			let currentDate = new Date(startDate);
			let endDate = new Date(stopDate);
			while (currentDate <= endDate) {
					dateArray.push(moment((new Date (currentDate))).format('Do MMM YY'));
					currentDate = new Date(currentDate).setDate(new Date(currentDate).getDate() + 1);
			}
			return dateArray;
		},
		checkIfDateWithinDueDate(date, dueDate) {
			let dateVal = new Date(date);
			let dueDateVal = new Date(dueDate);
			if(dateVal && dueDateVal && dateVal <= dueDateVal) {
				return true;
			} else {
				return false;
			}
		},
		formatAuditMissingLogs(tempArr) {
			this.auditMissingLogsCategoryList = [];
			let missingLogs = [];
			let taskItems = [];
			let currentDate = new Date();
			for (let i = 0; i < tempArr.length; i++) {
				let singleLabel = tempArr[i].name;
				taskItems.push({ text: singleLabel, value: singleLabel });
				let id = tempArr[i].basics;
				let categoryDataList = tempArr[i].data;
				for(let j = 0; j < categoryDataList.length; j++) {
					let localLogs = {
						category_name: `<div>${singleLabel}</div>`,
						category_id: id,
					};
					localLogs.intermediate_category_name = categoryDataList[j].intermediate_category_name;
					localLogs.due_date = categoryDataList[j].due_date;
					localLogs.completion_date = categoryDataList[j].completion_date;
					for(let k = 0; k < this.dateLabels.length; k++) {
						let dateLabel = this.dateLabels[k];
						let dueDate = new Date(localLogs.due_date);
						let formattedDueDate = moment(dueDate).format('Do MMM YY');
						if((!localLogs.completion_date || localLogs.completion_date == 'NaT') && currentDate > dueDate && formattedDueDate == dateLabel) {
							localLogs[this.dateLabels[k]] = '<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>';
						} else {
							localLogs[this.dateLabels[k]] = '';
						}
					}
					missingLogs.push(localLogs);
				}
			}

			let labelsArr = [];
			let backgroundColorArr = [];
			let countArr = [];

			for(let x = 0; x < this.dateLabels.length; x++) {
				let label = this.dateLabels[x];
				let count = 0;
				for(let y = 0; y < missingLogs.length; y++) {
					let singleObj = missingLogs[y];
					if(singleObj[label]) {
						count++;
					}
				}
				labelsArr.push(label);
				backgroundColorArr.push('#d60918');
				countArr.push(count);
			}
			this.auditMissingLogsCategoryList = [...missingLogs];
			this.dataSets.labels = [...labelsArr];
			this.dataSets.datasets[1].backgroundColor = [...backgroundColorArr];
			this.dataSets.datasets[1].data = [...countArr];
		},
		formatData(tempArr) {
			let labels = [];
			let missingLogs = [];
			let taskItems = [];
			let categoryItems = [];

			for (let i = 0; i < tempArr.length; i++) {
				let singleLabel = tempArr[i].name;
				taskItems.push({ text: singleLabel, value: singleLabel });
				let id = tempArr[i].basics;
				let localLogs = {
					Task: `<div>${singleLabel}</div>`,
					task_id: id,
				};
				if (tempArr[i].intermediate_category_name) {
					localLogs.Category = tempArr[i].intermediate_category_name;
					categoryItems.push({
						text: localLogs.Category,
						value: localLogs.Category,
					});
				}
				let records = [...tempArr[i].records];
				for (let j = 0; j < records.length; j++) {
					let singleRecord = records[j];
					if(moment(singleRecord.due_date) >= moment(this.fromDate) &&  moment(singleRecord.due_date) <= moment(this.toDate)) {
						if (singleRecord.completed == 1) {
							localLogs[moment(singleRecord.due_date).format("Do MMM YY")] = "";
						} else if (singleRecord.unassigned == 1) {
							localLogs[moment(singleRecord.due_date).format("Do MMM YY")] = "-";
						} else {
							localLogs[moment(singleRecord.due_date).format("Do MMM YY")] =
								'<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>';
						}
						let label = moment(singleRecord.due_date).format("Do MMM YY");
						let check = labels.find((el) => el == label);
						if (check === undefined) {
							labels.push(label);
						}
					}
				}
				missingLogs.push(localLogs);
			}
			this.removeDuplicates(categoryItems, "value", "category");
			this.removeDuplicates(taskItems, "value", "task");
			this.labels = labels;
			this.missingLogData = missingLogs;
			this.missingLogData1 = missingLogs;

			if (this.missingLogType == "equipments_and_products_missing_logs") {
				this.missingLogData = [...this.missingLogData1].filter((item) => {
					if (
						item.Category == "PM Checklist" ||
						item.Category == "AM Checklist" ||
						item.Category == "Broiler Checklist" ||
						item.Category == "Dessert Checklist"
					) {
						return item;
					}
				});
			}
			let firstArr = {};
			let firstColorArr = [];
			let firstColorCountArr = [];
			let secondArr = {};
			let secondColorArr = [];
			let secondColorCountArr = [];
			let datasetLabels = labels.filter((el) => el != "Task");
			for (let k = 0; k < missingLogs.length; k++) {
				let tempObj = { ...missingLogs[k] };
				for (let prop in tempObj) {
					if (prop != "Task") {
						if (labels.includes(prop)) {
							if (
								tempObj[prop] ==
								'<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>'
							) {
								if (firstArr[prop]) {
									firstArr[prop] = firstArr[prop] + 1;
								} else {
									firstArr[prop] = 1;
								}
							} else if (
								tempObj[prop] ==
								'<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>'
							) {
								if (secondArr[prop]) {
									secondArr[prop] = secondArr[prop] + 1;
								} else {
									secondArr[prop] = 1;
								}
							}
						}
					}
				}
			}
			for (let prop in firstArr) {
				firstColorArr.push(firstArr[prop]);
				firstColorCountArr.push("#d60918");
			}
			for (let prop in secondArr) {
				secondColorArr.push(secondArr[prop]);
				secondColorCountArr.push("#d26300");
			}
			this.dataSets.labels = [...datasetLabels];
			this.dataSets.datasets[1].backgroundColor = [...firstColorCountArr];
			this.dataSets.datasets[1].data = [...firstColorArr];
			// this.dataSets.datasets[0].backgroundColor = [...secondColorCountArr];
			// this.dataSets.datasets[0].data = [...secondColorArr];
		},
		exportAuditMissingLogByCategoryCSV() {
			let data = this.auditMissingLogsCategoryList.map((el) => ({
				...el,
			}));
			let results = [];
			for(let i = 0; i < data.length; i++) {
				let obj = {...data[i]};
				let tempObj = {};
				for(let prop in obj) {
					if(prop == 'category_name') {
						tempObj['Category'] = obj[prop].replace('<div>', '').replace('</div>', '');
					} else if(prop == 'intermediate_category_name') {
						tempObj['Intermediate Category'] = obj[prop];
					} else if(prop != 'category_id' && prop != 'due_date' && prop != 'completion_date') {
						tempObj[prop] = obj[prop] == '<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>' ? 'N' : '';
					}
				}
				results.push(tempObj);
			}
			let fileName = "Missing_Logs_Audit_By_Category";
			if (this.store_name) {
				let tempFileName = this.store_name.replace(/\s/g, "_");
				tempFileName = tempFileName.replace(/,/g, "_");
				fileName = fileName + tempFileName + "_";
			}
			fileName = fileName + this.fromDate + "_to_" + this.toDate;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data: results, fileName, exportType });
		},
		exportAuditMissingLogByTaskCSV() {
			let data = this.auditMissingLogsTaskList.map((el) => ({
				...el,
			}));
			let results = [];
			for(let i = 0; i < data.length; i++) {
				let obj = {...data[i]};
				let tempObj = {};
				for(let prop in obj) {
					if(prop == 'task') {
						tempObj['Task'] = obj[prop].replace('<div>', '').replace('</div>', '');
					} else if(prop == 'category') {
						tempObj['Category'] = obj[prop];
					} else if(prop == 'intermediate_category') {
						tempObj['Intermediate Category'] = obj[prop];
					} else if(prop != 'task_id' && prop != 'due_date' && prop != 'completion_date') {
						tempObj[prop] = obj[prop] == '<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>' ? 'N' : '';
					}
				}
				results.push(tempObj);
			}
			let fileName = "Missing_Logs_Audit_By_Task_";
			if (this.store_name) {
				let tempFileName = this.store_name.replace(/\s/g, "_");
				tempFileName = tempFileName.replace(/,/g, "_");
				fileName = fileName + tempFileName + "_";
			}
			fileName = fileName + this.fromDate + "_to_" + this.toDate;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data: results, fileName, exportType });
		},
		exportAuditMissingLogBySubTaskCSV() {
			let data = this.auditMissingLogsSubTaskList.map((el) => ({
				...el,
			}));
			let results = [];
			for(let i = 0; i < data.length; i++) {
				let obj = {...data[i]};
				let tempObj = {};
				for(let prop in obj) {
					if(prop == 'subtask') {
						tempObj['Sub Task'] = obj[prop].replace('<div>', '').replace('</div>', '');
					} else if(prop == 'category') {
						tempObj['Category'] = obj[prop];
					} else if(prop == 'intermediate_category') {
						tempObj['Intermediate Category'] = obj[prop];
					} else if(prop != 'subtask_id' && prop != 'due_date' && prop != 'completion_date') {
						tempObj[prop] = obj[prop] == '<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>' ? 'N' : '';
					}
				}
				results.push(tempObj);
			}
			let fileName = "Missing_Logs_Audit_By_Sub_Task_";
			if (this.store_name) {
				let tempFileName = this.store_name.replace(/\s/g, "_");
				tempFileName = tempFileName.replace(/,/g, "_");
				fileName = fileName + tempFileName + "_";
			}
			fileName = fileName + this.fromDate + "_to_" + this.toDate;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data: results, fileName, exportType });
		},
		downloadCategoryPerformanceDetails() {
			let data = this.missingLogData.map((el) => ({
				...el,
			}));
			for (let i = 0; i < data.length; i++) {
				for (let prop in data[i]) {
					if (
						data[i][prop] &&
						prop != "Task" &&
						prop != "Category" &&
						prop != "task_id"
					) {
						if (
							data[i][prop] ==
							'<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>'
						) {
							data[i][prop] = "";
						} else if (data[i][prop] == "-") {
							data[i][prop] = "U";
						} else {
							data[i][prop] = "N";
						}
					} else if (data[i][prop] && prop == "Task") {
						data[i][prop] = data[i][prop]
							.replaceAll("<div>", "")
							.replaceAll("</div>", " ");
					} else if (data[i][prop] && prop == "Category") {
						data[i][prop] = data[i][prop];
					} else if (data[i][prop] && prop == "task_id") {
						data[i][prop] = data[i][prop];
					}
				}
			}
			let fileName = "Missing_Logs_Tasks_";
			if (this.store_name) {
				let tempFileName = this.store_name.replace(/\s/g, "_");
				tempFileName = tempFileName.replace(/,/g, "_");
				fileName = fileName + tempFileName + "_";
			}
			fileName = fileName + this.fromDate + "_to_" + this.toDate;
			const exportType = exportFromJSON.types.csv;
			exportFromJSON({ data, fileName, exportType });
		},
		getSubTask(task_id) {
			if (this.fromDate && this.toDate) {
				this.currentStep = "subtask";
				const params = {
					task: task_id,
					start_date: this.fromDate,
					end_date: this.toDate,
				};

				LabourPalnningService.getSubTaskByTask(params)
					.then((response) => {
						let responseData = JSON.parse(response.data);
						this.task_reports_subtasks = responseData.results;
						let arr = [];
						for (
							let dt = new Date(this.fromDate);
							dt <= new Date(this.toDate);
							dt.setDate(dt.getDate() + 1)
						) {
							arr.push(new Date(dt));
						}
						this.subtasks_reports_dates = arr;
					})
					.catch((error) => {
						console.error(error);
					});
			}
		},
		getTaskReportImageClass(date, records) {
			if (date && records.length > 0) {
				let completed = false;
				for (let i = 0; i < records.length; i++) {
					if (records[i].is_completed == true) {
						if (
							moment(records[i].due_date).format("YYYY-MM-DD") ==
							moment(date).format("YYYY-MM-DD")
						) {
							completed = true;
						}
					}
				}
				if (completed == true) {
					return "color: #d26300";
				} else {
					return "";
				}
			} else {
				return "";
			}
		},
		getImageUrl(path) {
			let params = {
				attachment_id: path,
			};

			LabourPalnningService.getTaskAttachmentNew(params)
				.then((res) => {
					let responseData = JSON.parse(res.data);
					this.taskReportsImgArr.push(responseData.url);
				})
				.catch((err) => {
					console.error(err);
				});
		},
		checkIfTaskIsCompleted(records, date) {
			if (records.length > 0) {
				let result = false;
				for (let i = 0; i < records.length; i++) {
					if (
						moment(records[i].time_of_completion).format("YYYY-MM-DD") ==
						moment(date).format("YYYY-MM-DD")
					) {
						if (
							moment(records[i].time_of_completion).format("YYYY-MM-DD") <=
							moment(records[i].due_date).format("YYYY-MM-DD")
						) {
							result = true;
						}
					}
				}
				return result;
			} else {
				return false;
			}
		},
		getTaskValue(records, date) {
			if (records.length > 0) {
				let subtask_type = "temperature";
				let index = 0;
				let result = "";
				for (let i = 0; i < records.length; i++) {
					if (
						moment(records[i].time_of_completion).format("YYYY-MM-DD") ==
						moment(date).format("YYYY-MM-DD")
					) {
						if (
							moment(records[i].time_of_completion).format("YYYY-MM-DD") <=
							moment(records[i].due_date).format("YYYY-MM-DD")
						) {
							index = i;
							subtask_type = records[i].subtask_type;
						}
					}
				}
				if (subtask_type == "datetime") {
					result = records[index].datetime_value;
				} else if (subtask_type == "radio_options") {
					result = records[index].num_value;
				} else if (subtask_type == "yes_no") {
					result = records[index].boolean_value ? "-" : "No";
					if (records[index].not_applicable) {
						result = "N.A";
					}
				} else if (subtask_type == "temperature") {
					if (records[index].not_applicable === true) {
						result = `NA`;
					} else if (records[index].num_value != null) {
						if (
							records[index].num_value >= records[index].num_value_min &&
							records[index].num_value <= records[index].num_value_max
						) {
							result = `<div>Test Value: <span style="color:green;">${records[index].num_value}&deg C</span></div>`;
						} else if (records[index].retest_value != null) {
							if (
								records[index].retest_value >= records[index].num_value_min &&
								records[index].retest_value <= records[index].num_value_max
							) {
								result = `<div>Test Value: <span style="color:red;">${
									records[index].num_value
								}&deg C</span></div><div>Retest Value: ${
									records[index].retest_value == 0 ||
									records[index].retest_value
										? records[index].retest_value + "&deg C"
										: "-"
								}</div>`;
							} else {
								result = `<div>Test Value: <span style="color:red;">${
									records[index].num_value
								}&deg C</span></div><div>Retest Value: <span style="color:red;">${
									records[index].retest_value == 0 ||
									records[index].retest_value
										? records[index].retest_value + "&deg C"
										: "-"
								}<span></div>`;
							}
						} else {
							return "-";
						}
					} else {
						result = `<div>Test Value: ${
							records[index].num_value
						}&deg C</div><div>Retest Value: ${
							records[index].retest_value == 0 || records[index].retest_value
								? records[index].retest_value + "&deg C"
								: "-"
						}</div>`;
					}
				} else if (subtask_type == "tpc") {
					if (records[index].not_applicable === true) {
						result = `NA`;
					} else if (records[index].num_value != null) {
						if (
							records[index].num_value >= records[index].num_value_min &&
							records[index].num_value <= records[index].num_value_max
						) {
							result = `<div>Test Value: <span style="color:green;">${records[index].num_value} TPM</span></div>`;
						} else if (records[index].retest_value != null) {
							if (
								records[index].retest_value >= records[index].num_value_min &&
								records[index].retest_value <= records[index].num_value_max
							) {
								result = `<div>Test Value: <span style="color:red;">${
									records[index].num_value
								} TPM</span></div><div>Retest Value: ${
									records[index].retest_value == 0 ||
									records[index].retest_value
										? records[index].retest_value + " TPM"
										: "-"
								}</div>`;
							} else {
								result = `<div>Test Value: <span style="color:red;">${
									records[index].num_value
								} TPM</span></div><div>Retest Value: <span style="color:red;">${
									records[index].retest_value == 0 ||
									records[index].retest_value
										? records[index].retest_value + " TPM"
										: "-"
								}<span></div>`;
							}
						} else {
							return "-";
						}
					} else {
						result = `<div>Test Value: ${
							records[index].num_value
						} TPM</div><div>Retest Value: ${
							records[index].retest_value == 0 || records[index].retest_value
								? records[index].retest_value + " TPM"
								: "-"
						}</div>`;
					}
				} else if (subtask_type == "number") {
					result = records[index].num_value;
				} else if (subtask_type == "scoring") {
					result = records[index].num_value;
				} else if (subtask_type == "scoring") {
					result = records[index].num_value;
				} else if (subtask_type == "rating") {
					result = records[index].num_value;
				} else if (subtask_type == "checklist") {
					result = records[index].num_value;
				} else if (subtask_type == "text") {
					result = records[index].text_value;
				}
				return result;
			} else {
				return "-";
			}
		},
		checkIfDateHasImage(records, date) {
			if (records.length > 0) {
				let result = false;
				for (let i = 0; i < records.length; i++) {
					if (records[i].attachments.length > 0) {
						if (
							moment(records[i].due_date).format("YYYY-MM-DD") ==
							moment(date).format("YYYY-MM-DD")
						) {
							result = true;
						}
					}
				}
				return result;
			} else {
				return false;
			}
		},
		checkIfDateHasComment(records, date) {
			if (records.length > 0) {
				let result = false;
				for (let i = 0; i < records.length; i++) {
					if (records[i].comment) {
						if (
							moment(records[i].due_date).format("YYYY-MM-DD") ==
							moment(date).format("YYYY-MM-DD")
						) {
							result = true;
						}
					}
				}
				return result;
			} else {
				return false;
			}
		},
		checkIfDateHasTemperature(records, date) {
			if (records.length > 0) {
				let result = false;
				for (let i = 0; i < records.length; i++) {
					if (records[i].is_completed == true) {
						if (
							moment(records[i].due_date).format("YYYY-MM-DD") ==
							moment(date).format("YYYY-MM-DD")
						) {
							result = true;
						}
					}
				}
				return result;
			} else {
				return false;
			}
		},
		getTestValueDate(records, date) {
			if (records.length > 0) {
				let result = 0;
				for (let i = 0; i < records.length; i++) {
					if (records[i].is_completed == true) {
						if (
							moment(records[i].due_date).format("YYYY-MM-DD") ==
							moment(date).format("YYYY-MM-DD")
						) {
							result = records[i].num_value;
						}
					}
				}
				return result + "&deg; C";
			} else {
				return "-";
			}
		},
		getRetestValueDate(records, date) {
			if (records.length > 0) {
				let result = 0;
				for (let i = 0; i < records.length; i++) {
					if (records[i].is_completed == true) {
						if (
							moment(records[i].due_date).format("YYYY-MM-DD") ==
							moment(date).format("YYYY-MM-DD")
						) {
							result = records[i].retest_value ? records[i].retest_value : "-";
						}
					}
				}
				return result + "&deg; C";
			} else {
				return "-";
			}
		},
		openCommentModal(records, date) {
			if (records.length > 0) {
				let result = false;
				for (let i = 0; i < records.length; i++) {
					if (records[i].comment) {
						if (
							moment(records[i].due_date).format("YYYY-MM-DD") ==
							moment(date).format("YYYY-MM-DD")
						) {
							this.taskReportsImageComment = records[i].comment;
							this.showTaskReportsCommentModal = true;
						}
					}
				}
				return result;
			}
		},
		resetData() {
			this.currentStep = "task";
		},
		openAttachmentsModal(records, date) {
			try {
				if (records.length > 0) {
					this.taskReportsImgArr = [];
					let imageObj = {};
					if (date) {
						for (let i = 0; i < records.length; i++) {
							if (
								moment(records[i].due_date).format("YYYY-MM-DD") ==
								moment(date).format("YYYY-MM-DD")
							) {
								imageObj = { ...records[i] };
							}
						}
					}
					if (
						imageObj &&
						Object.keys(imageObj).length === 0 &&
						Object.getPrototypeOf(imageObj) === Object.prototype
					) {
						this.$notify.error({
							title: "Fail",
							message: "Failed to open image",
						});
					} else {
						for (let i = 0; i < imageObj.attachments.length; i++) {
							this.getImageUrl(imageObj.attachments[i]);
						}
						this.showTaskReportsImageModal = true;
						this.taskReportsImageComment = imageObj.comment;
					}
				} else {
					this.$notify.error({
						title: "Fail",
						message: "No attachments available",
					});
				}
			} catch (error) {
				console.error(error);
				this.$notify.error({
					title: "Fail",
					message: "Failed to open image",
				});
			}
		},
		formatAuditMissingLogCategoryTaskData(data) {
			let results = [];
			let currentDate = new Date();
			for(let i = 0; i < data.length; i++) {
				let singleObj = data[i];
				let tempObj = {
					'category': singleObj.category_name,
					'intermediate_category': singleObj.intermediate_category_name,
					'task': singleObj.name,
					'task_id': singleObj.basics
				};
				for(let k = 0; k < this.dateLabels.length; k++) {
					let dateVal = this.dateLabels[k];
					for(let j = 0; j < singleObj.data.length; j++) {
						let dueDate = singleObj.data[j].due_date;
						dueDate = new Date(dueDate);
						let dueDateLabel = moment(dueDate).format("Do MMM YY");
						let completionDate = singleObj.data[j].completion_date;
						if(currentDate > dueDate && !completionDate) {
							if(dueDateLabel == dateVal) {
								tempObj[dateVal] = '<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>';
							} else {
								tempObj[dateVal] = '';
							}
						} else if(completionDate && new Date(completionDate) > dueDate) {
							if(dueDateLabel == dateVal) {
								tempObj[dateVal] = '<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>';
							} else {
								tempObj[dateVal] = '';
							}
						} else {
							tempObj[dateVal] = '';
						}
					}
				}
				results.push(tempObj);
			}
			this.auditMissingLogsTaskList = [...results];
			this.currentAuditMissingLogStep = "task";
		},
		formatAuditMissingLogCategorySubTaskData(data) {
			let results = [];
			let currentDate = new Date();
			for(let i = 0; i < data.length; i++) {
				let singleObj = data[i];
				let tempObj = {
					'subtask': singleObj.name,
					'subtask_id': singleObj.basics
				};
				for(let k = 0; k < this.dateLabels.length; k++) {
					let dateVal = this.dateLabels[k];
					for(let j = 0; j < singleObj.data.length; j++) {
						let dueDate = singleObj.data[j].due_date;
						dueDate = new Date(dueDate);
						let dueDateLabel = moment(dueDate).format("Do MMM YY");
						let completionDate = singleObj.data[j].completion_date;
						if(currentDate > dueDate && !completionDate) {
							if(dueDateLabel == dateVal) {
								tempObj[dateVal] = '<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>';
							} else {
								tempObj[dateVal] = '';
							}
						} else if(completionDate && new Date(completionDate) > dueDate) {
							if(dueDateLabel == dateVal) {
								tempObj[dateVal] = '<i class="el-icon-error text-danger text-lg" style="color: #F56C6C !important;"></i>';
							} else {
								tempObj[dateVal] = '';
							}
						} else {
							tempObj[dateVal] = '';
						}
					}
				}
				results.push(tempObj);
			}
			this.auditMissingLogsSubTaskList = [...results];
			this.currentAuditMissingLogStep = "subtask";
		},
		selectAuditMissingLogByCategory(category_id, intermediate_category_name) {
			this.is_loading = true;
			this.selectedAuditMissingLogCategoryId = category_id;
			let intermediate_category = this.auditIntermediateCategories.find(el => el.name == intermediate_category_name);
			this.selectedAuditMissingLogIntermediateCategory = intermediate_category ? intermediate_category.id ? intermediate_category.id : null : null;
			const params = {
				basics: "task",
				start_date: this.fromDate,
				end_date: this.toDate,
				include_dates: true,
				task: null,
				filters: {
					outlets: [
						this.selectedOutlet
					]
				},
				category: category_id,
				designation: null,
				main_category: 'audit',
				intermediate_category: intermediate_category ? intermediate_category.id ? intermediate_category.id : null : null
			};
			LabourPalnningService.lastAuditConducted(params)
			.then(res => {
				const responseData = JSON.parse(res.data);
				this.formatAuditMissingLogCategoryTaskData(responseData.results);
			})
			.catch(err => console.error(err))
			.finally(res => this.is_loading = false);
		},
		selectAuditMissingLogByTask(task_id, intermediate_category_name) {
			this.is_loading = true;
			this.selectedAuditMissingLogTaskId = task_id;
			const params = {
				basics: "subtask",
				start_date: this.fromDate,
				end_date: this.toDate,
				include_dates: true,
				employee: null,
				task: task_id,
				filters: {
					outlets: [
						this.selectedOutlet
					]
				},
				main_category: 'audit',
				category: this.selectedAuditMissingLogCategoryId,
				designation: null,
				intermediate_category: this.selectedAuditMissingLogIntermediateCategory
			};
			LabourPalnningService.lastAuditConducted(params)
			.then(res => {
				const responseData = JSON.parse(res.data);
				this.formatAuditMissingLogCategorySubTaskData(responseData.results);
			})
			.catch(err => console.error(err))
			.finally(result => this.is_loading = false);
		},
	},
};
</script>

<style lang="scss">
.missing-logs {
	#chart-container {
		background: #ffffff;
		position: relative;
		height: 50vh;
		overflow: hidden;
	}
	.missing-log-title {
		font-size: 16px;
		margin: 0;
		font-weight: 600;
		span {
			font-weight: 400;
			color: #333;
		}
	}
	.el-table.custom-category__details-table {
		th {
			min-height: 35px !important;
		}
		.el-table__header-wrapper {
			table {
				thead {
					th {
						background-color: #502314 !important;
						/* padding: 0 !important; */
						min-height: 35px !important;
						.cell {
							color: #fff !important;
							.caret-wrapper {
								visibility: hidden;
							}
							span {
								div {
									color: #502314 !important;
								}
							}
						}
					}
					th.el-table__cell {
						background-color: #502314 !important;
						/* padding: 0 !important; */
						min-height: 35px !important;
						.cell {
							color: #fff !important;
							font-size: 10px !important;
							.caret-wrapper {
								visibility: hidden;
							}
							span {
								div {
									color: #502314 !important;
								}
							}
						}
					}
				}
			}
		}
	}
	.el-table.custom-category__details-table th.el-table__cell {
		background-color: #502314 !important;
		/* padding: 0 !important; */
		th {
			min-height: 35px !important;
		}
		.cell {
			color: #fff !important;
			font-size: 10px !important;
			span {
				div {
					color: #502314 !important;
				}
			}
		}
	}
}
.scoped_task:first-child {
	text-decoration: underline;
	font-weight: 600;
	color: #502314;
	cursor: pointer;
	font-size: 12px;
}
.el-table--enable-row-transition .el-table__body td.el-table__cell {
	font-size: 12px !important;
}
.missing-log-link-text {
	text-decoration: underline;
	font-weight: 600;
	color: #502314;
	cursor: pointer;
	font-size: 12px;
}
.missing-log-title-text {
	font-weight: 600;
	color: #502314;
	font-size: 12px;
}
</style>
